import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInputGroup, LinkedInput, NoContentBox } from 'components/basic'
import { Installation } from 'config'
import { notify, Translate } from 'helpers'
import Select from 'react-select'
import http from 'API/http'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'

class Subscriptions extends Component {
  constructor (props) {
    super(props)
    this.state = {
      subscriptions: [],
      services: [],
      orders: [],
      loading: true,
      serviceToConnect: {},
      selectedService: {},
      accessId: ''
    }
  }

  componentDidMount () {
    this.setSubscriptions(this.props.subscriptions, this.props.accessId, this.props.services)
  }

  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.setSubscriptions(props.subscriptions, props.accessId, props.services)
  }

  setSubscriptions (subscriptions, accessId, services) {
    this.setState({loading: true})
    this.setState({subscriptions: subscriptions, accessId: accessId, services: services})
    this.getOrders(accessId)
  }

  async getOrders (id) {
    var [err, res] = await http.get('2.4/orders', { accessId: id })
    this.setState({orders: res.data, loading: false})
  }

  async deactivateService () {
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      operation: 'DEACTIVATE',
      requestedDateTime: (!this.state.selectedService.operationDate ? null : this.state.selectedService.operationDate)
    })
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({deactivateModal: false})
    notify.alert('', 'The service will be deactivated ' + (!this.state.selectedService.operationDate ? 'soon.' : moment(this.state.selectedService.operationDate).format('YYYY-MM-DD')), 'success')
    this.props.callback()
  }

  async modifyService () {
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      spSubscriptionId: this.state.selectedService.spSubscriptionId,
      spReference: this.state.selectedService.spReference,
      operation: 'MODIFY'
    })
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({editModal: false})
    notify.alert('', 'References has been updated!', 'success')
    this.props.callback()
  }

  isDateValid (current) {
    if (current === null) current = moment()
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }

  async changeService () {
    if (!this.state.serviceToConnect.service) return notify.warn('You need to select a service')
    this.setState({activating: true})

    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      oldService: this.state.selectedService.service,
      service: this.state.serviceToConnect.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      requestedDateTime: (!this.state.serviceToConnect.operationDate ? null : this.state.serviceToConnect.operationDate),
      operation: 'CHANGE'
    })

    if (err) return notify.alert('', res.cause, 'error')
    this.setState({changeModal: false, activating: false})
    notify.alert('', 'Change service operation successfully created', 'success')
    this.props.callback()
  }

  async suspendService () {
    this.setState({activating: true})

    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      requestedDateTime: (!this.state.selectedService.operationDate ? null : this.state.selectedService.operationDate),
      operation: 'SUSPEND'
    })
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({suspendModal: false, activating: false})
    notify.alert('', 'Suspend service operation successfully created', 'success')
    this.props.callback()
  }

  async resumeService () {
    this.setState({activating: true})

    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      requestedDateTime: (!this.state.selectedService.operationDate ? null : this.state.selectedService.operationDate),
      operation: 'RESUME'
    })
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({resumeModal: false, activating: false})
    notify.alert('', 'Resume service operation successfully created', 'success')
    this.props.callback()
  }

  getOperationalState (state) {
    switch (state) {
      case 'ACTIVE':
        return <span className='label orders-label label-success'><i className='fa fa-fw fa-check'/><b>{state}</b></span>
      case 'INACTIVE':
        return <span className='label orders-label label-danger'><i className='fa fa-fw fa-times-circle'/><b>{state}</b></span>
      case 'DISABLED':
        return <span className='label orders-label label-dark'><i className='fa fa-fw fa-ban'/><b>{state}</b></span>
      default:
        return <span className='label orders-label label-dark'><b>{state}</b></span>
    }
  }

  render () {
    return (
      <div>
        <StaticBox cols={12} icon='handshake-o' title={Translate({'SE': 'Tjänster', 'EN': 'Subscriptions'})}>
          <FlowTable loading={this.state.loading} data={this.state.subscriptions.map(subscription => [
            <div style={{'display': 'flex'}}>
              {[
                <a hidden={((typeof this.state.orders.find(order => order.subscriptionId === subscription.subscriptionId && order.state === 'RECEIVED') === 'object' || subscription.deactivationDate) && this.props.access === 'FLOW')} key={subscription.service + 1} data-tip='Manage Subscription' onClick={e => this.setState({selectModal: true, selectedService: subscription})} className='table-link'><i className='fa fa-edit' /></a>,
                (Installation.enable.tickets && Installation.enable.ticketsCreate) ? <a key={subscription.service + 2} data-tip='Create Ticket' onClick={e => (window.location = ('/#/ticket/create/' + this.state.accessId + '/' + subscription.subscriptionId))} className='table-link'><i className='fa fa-ticket' /></a> : (!Installation.enable.ticketsCreate) ? <a onClick={e => this.setState({ticketModal: true})} className='table-link'><i className='fa fa-ticket' /></a> : <i className='fa fa-ban text-muted' />
              ]}
            </div>,
            this.getOperationalState(subscription.operationalState),
            subscription.service,
            (!subscription.activationDate ? '' : moment(subscription.activationDate).format('YYYY-MM-DD HH:mm:ss')),
            subscription.deactivationDate ? moment(subscription.deactivationDate).format('YYYY-MM-DD HH:mm:ss') : '',
            subscription.spReference,
            subscription.spSubscriptionId,
            (subscription.characteristics && subscription.characteristics.fixedIp ? <span className='label table-label label-success'>YES</span> : <span className='label table-label label-danger'>NO</span>),
            (subscription.characteristics && subscription.characteristics.ipAddresses.length !== 0 ? subscription.characteristics.ipAddresses.map(address => (' [' + address + '] ')) : ''),
            (subscription.characteristics ? subscription.characteristics.SLA : ''),
            subscription.option82
          ])}>
            <tr>
              <th className='buttons' >Actions</th>
              <th>State</th>
              <th>Service</th>
              <th>Activation Date</th>
              <th>Deactivation Date</th>
              <th>Your Internal Reference</th>
              <th>Subscription  Reference</th>
              <th>Fixed IP</th>
              <th>IP Addresses</th>
              <th>SLA</th>
              <th>Option 82</th>
            </tr>
          </FlowTable>
        </StaticBox>
        <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.selectModal} close={e => this.setState({selectModal: false})}>
          <div className='col-md-9 col-md-push-1 selection-buttons-wrapper'>
            <div className='selection-buttons'>
              <a className='selection-button' onClick={() => this.setState({deactivateModal: true, selectModal: false})}><i className='fa fa-fw fa-times' /> Deactivate <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'DISABLED' ? 'hidden' : '')} onClick={() => this.setState({suspendModal: true, selectModal: false})}><i className='fa fa-fw fa-ban' /> Suspend <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'DISABLED' ? '' : 'hidden')} onClick={() => this.setState({resumeModal: true, selectModal: false})}><i className='fa fa-fw fa-forward' /> Resume <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'DISABLED' ? 'hidden' : '')} onClick={() => this.setState({editModal: true, selectModal: false})}><i className='fa fa-fw fa-edit' /> Edit Parameters <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'DISABLED' ? 'hidden' : '')} onClick={() => this.setState({changeModal: true, selectModal: false})}><i className='fa fa-fw fa-cog' /> Change Service <i className='fa fa-fw fa-arrow-right' /></a>
            </div>
          </div>
        </Modal>
        <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.deactivateModal} close={e => this.setState({deactivateModal: false, selectedService: {}})} buttons={[
            { text: 'Disconnect', event: e => this.deactivateService() }
        ]}>
          <label>Deactivation time</label>
          <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
            this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
        </Modal>
        <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.resumeModal} close={e => this.setState({resumeModal: false, selectedService: {}})} buttons={[
            { text: 'Resume', event: e => this.resumeService() }
        ]}>
          <label>Operation time</label>
          <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
            this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
        </Modal>
        <Modal title={'Edit references for ' + this.state.selectedService.service} noOverflow isOpen={this.state.editModal} close={e => this.setState({editModal: false, selectedService: {}})} buttons={[
            { text: 'Save', event: e => this.modifyService() }
        ]}>
          <LinkedInputGroup ref={(form) => { this.editForm = form }}>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='selectedService.spReference' />
              </div>
              <div className='form-group col-md-12'>
                <label>Subscription Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='selectedService.spSubscriptionId' />
              </div>
            </div>
          </LinkedInputGroup>
        </Modal>
        <Modal title={'Suspend ' + this.state.selectedService.service} noOverflow isOpen={this.state.suspendModal} close={e => this.setState({suspendModal: false, selectedService: {}})} buttons={[
            { text: 'Suspend', event: e => this.suspendService() }
        ]}>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Suspended From</label>
              <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
                this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
              }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'Select a date'}} timeFormat={'HH:mm'} renderInput={props =>
                <div className='input-group'>
                  <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                  <input {...props} className='form-control' />
                </div>
              } />
            </div>
          </div>
        </Modal>
        <Modal noOverflow title={'Change ' + this.state.selectedService.service} isOpen={this.state.changeModal} close={e => this.setState({changeModal: false, selectedService: {}})} buttons={[
          { text: 'Change Service', event: e => this.changeService(), disabled: true }
        ]}>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Operation Date</label>
              <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.serviceToConnect.operationDate} onChange={date => {
                this.setState({serviceToConnect: {...this.state.serviceToConnect, operationDate: date}})
              }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'Select a date'}} timeFormat={'HH:mm'} renderInput={props =>
                <div className='input-group'>
                  <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                  <input {...props} className='form-control' />
                </div>
              } />
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>New Service</label>
              <Select
                value={this.state.serviceToConnect}
                onChange={service => this.setState({serviceToConnect: service})}
                options={this.state.services.filter(service => ((service.productGroup_id === this.state.selectedService.productGroup_id || !service.productGroup_id) && service.service !== this.state.selectedService.service))}
                valueKey='service'
                labelKey='service'
                clearable={false}
              />
            </div>
          </div>
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
      </div>
    )
  }
}
export default Subscriptions



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/Subscriptions.js